export const AuthRoutes = {
  login: "/login",
  register: "/register",
  resetPassword: "/reset-password",
  resetPasswordToken: "/reset-password/:token",
  landingPage: "/",
};

export const DashboardRoutes = {
  dashboard: "/dashboard",
  messages: "/dashboard/messages",
  animalCards: "/dashboard/animal-cards",
  animalCardsNewCard: "/dashboard/animal-cards/add-new-card",
  animalCardsCard: "/dashboard/animal-cards/:id",
  voluntary: "/dashboard/voluntary",
  employees: "/dashboard/employees",
  addNewEmployee: "/dashboard/employees/add-new-employee",
  accountSettings: "/dashboard/account-settings",
};
